import script from "./ProposalCreateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposalCreateModal.vue?vue&type=script&setup=true&lang=js"

import "./ProposalCreateModal.vue?vue&type=style&index=0&id=470d5592&lang=css"

const __exports__ = script;

export default __exports__